import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';
import { ArrowDirection } from '@/common/helios/Tooltip/types';
import { type ContentProps } from './Content';

type ContentWrapperProps = ElementWithProps<
  Pick<ContentProps, 'showArrow' | 'width' | 'left' | 'top'> & {
    arrowDirection: ArrowDirection;
    directionStartOrEnd: string;
    canMoveArrowLeftOrRight: boolean;
  }
>;

// All styles prefixed with -: can be overwritten by classes that are passed in the className prop
const baseContentStyles =
  'absolute z-[1000] min-h-[50px] rounded-xl p-xl normal-case -:bg-background-strong -:text-text-inverse -:after:left-[calc(48.5%+var(--arrow-offset-x,0px))] -:after:block';
const baseArrowStyles =
  'after:border-t-none after:absolute after:w-0 after:border-x-[5px] after:border-b-[6px] after:border-x-transparent after:content-[""] -:after:border-y-background-strong';

export const ContentWrapper = createComponent<ContentWrapperProps>(
  'span',
  props => ({
    className: cx(
      baseContentStyles,
      baseArrowStyles,
      { 'after:hidden': !props.showArrow },
      {
        'after:top-full  after:rotate-180': props.arrowDirection === 'top-arrow'
      },
      {
        'after:-top-[6px]': props.arrowDirection === 'bottom-arrow'
      },
      {
        'after:left-[99%] after:top-[calc(50%-5px+var(--arrow-offset-y,0px))] after:rotate-90':
          props.arrowDirection === 'left-arrow'
      },
      {
        'after:-left-[8px] after:top-[calc(50%-5px+var(--arrow-offset-y,0px))] after:-rotate-90':
          props.arrowDirection === 'right-arrow'
      },
      {
        'after:left-[calc(6.5%+var(--arrow-offset-x,0px))]':
          props.directionStartOrEnd === 'start' && props.canMoveArrowLeftOrRight
      },
      {
        'after:left-[calc(88.5%+var(--arrow-offset-x,0px))]':
          props.directionStartOrEnd === 'end' && props.canMoveArrowLeftOrRight
      }
    ),
    style: {
      width: props.width ? `${props.width}px` : '',
      top: props.top ? `${props.top}px` : '',
      left: props.left ? `${props.left}px` : ''
    }
  })
);

export const CloseButton = createComponent('button', {
  className:
    'ml-auto flex cursor-pointer border-none bg-transparent fill-icon-inverse p-0 hover:fill-icon-inverse-hover active:fill-icon-inverse-active'
});

export const Title = createComponent('span', {
  className: 'block pr-8 text-text-inverse t-heading-sm'
});

export const TitleContentWrapper = createComponent('span', {
  className: 'flex items-center'
});

export const BodyContentWrapper = createComponent('span', {
  className: 'mt-md block'
});
